import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./App.css";
import "leaflet/dist/leaflet.css";
import "./core/api/sentry.ts";
import { AppErrorBoundary } from "./components/routing/AppErrorBoundary.tsx";

createRoot(document.getElementById("root")!).render(
	<AppErrorBoundary scope='root'>
		<App />
	</AppErrorBoundary>,
);
